import pagesService from '@/services/pages'
import postsService from '@/services/posts'
import termsService from '@/services/terms'
import prevnextService from '@/services/prev-next'
import menusService from '@/services/menus'
import optionsService from '@/services/options'
import customfieldsService from '@/services/customfields'
import tweetsService from '@/services/tweets'
import donationService from '@/services/donation'
import mailchimpService from '@/services/mailchimp'

export const pages = pagesService
export const posts = postsService
export const terms = prevnextService
export const prevnext = menusService
export const menus = menusService
export const options = optionsService
export const customfields = customfieldsService
export const tweets = tweetsService
export const donation = donationService
export const mailchimp = mailchimpService

let fetchUrl
let fetchOptions = {}
if (process.env.NODE_ENV === 'development' && process.env.VUE_APP_DEV_DIST_URL) {
  fetchUrl = process.env.VUE_APP_DEV_DIST_URL
  if (process.env.VUE_APP_DEV_DIST_AUTH) {
    fetchOptions = {
      headers: {
        'Authorization': `Basic ${btoa(process.env.VUE_APP_DEV_DIST_AUTH)}`
      }
    }
  }
} else {
  fetchUrl = `${window.location.protocol}//${window.location.hostname}`
}

export const fetch = function (url, options = {}) {
  options = Object.assign(options, fetchOptions)
  return window.fetch(`${fetchUrl}${url}`, options)
}

export default {
  pages: pagesService,
  posts: postsService,
  terms: termsService,
  prevnext: prevnextService,
  menus: menusService,
  options: optionsService,
  customfields: customfieldsService,
  tweets: tweetsService,
  donation: donationService,
  mailchimp: mailchimpService
}
